export default __webpack_public_path__ + "static/media/ChinmayTumbe.90d55229.png";